import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import QuestionsBox from '../../core/components/questions/QuestionsBox';
import ProductsList from './ProductsList';
import InformationDetail from './InformationDetail';
import Observations from './Observations';
import BenefitBox from '../../landing/components/BenefitBoxContainer';
import CommunicationBox from '../../landing/components/CommunicationBoxContainer';
import Banner from '../../core/components/product/Banner';
import withVisibilityToggle from '../../core/enhancements/withVisibilityToggle';
import AutosPlansSubscription from './AutosPlansSubscription/Container';

const Background = styled.div`
    background-color: #f6f6f6;
`;

const Wrapper = styled.section`
  width: 100%;
  display: block;
  margin: 0 auto;
  @media(min-width:1000px) {
    width: 970px;
  }
`;

const DiscountBanner = withVisibilityToggle(Banner);

const hasDiscount = product => product.discount && product.discountId;

const getDiscountFrom = (productsData) => {
  const products = productsData.subscriptions;

  if (products) {
    const productWithDiscount = products.find(hasDiscount);
    return productWithDiscount ? productWithDiscount.discount : null;
  }

  return null;
};

const Subscription = ({ productsData, contentData, adData }) => {
  // TODO retirar linha abaixo depois que o desconto do semipro sair do ar
  const semiPRODiscountInfo = 'Desconto válido apenas para a primeira parcela dos Planos Profissionais.';

  function renderDefaultPlanView() {
    return (
      <Wrapper>
        <ProductsList products={productsData.subscriptions} />
        <Observations details={contentData.details} />
        <InformationDetail info={getDiscountFrom(productsData) ? semiPRODiscountInfo : contentData.infoDetail} />
        <BenefitBox benefits={contentData.benefits} />
      </Wrapper>
    );
  }

  function renderPlansSubscription() {
    const isAutos = adData.categoryId === 2020;

    if (isAutos) {
      return <AutosPlansSubscription productsData={productsData} />;
    }

    return renderDefaultPlanView();
  }

  return (
    <Fragment>
      <Background>
        <DiscountBanner
          showIf={getDiscountFrom(productsData)}
          content={contentData}
          discount={getDiscountFrom(productsData)}
          marginBottom={getDiscountFrom(productsData) ? '50px' : '0px'} // TODO retirar essa prop depois que o desconto do semipro sair do ar
        />
        {renderPlansSubscription()}
        <CommunicationBox showIf={contentData.showTelesales} telesales={contentData.telesales} bgColor="#f6f6f6" />
        <QuestionsBox questions={contentData.questions} />
      </Background>
    </Fragment>
  );
};

Subscription.propTypes = {
  productsData: PropTypes.object,
  contentData: PropTypes.object,
  adData: PropTypes.object,
};

Subscription.defaultProps = {
  productsData: {},
  contentData: {},
  adData: {},
};

export default Subscription;
